import { useQuery } from "@tanstack/react-query"

import { getTypes } from "@/api/getTypes.ts"

export default function RenderType({ id }: { id: number }) {
  const { data, isPending, isError } = useQuery({
    queryKey: ["types"],
    queryFn: () => getTypes(),
  })

  if (isPending) return <>Loading...</>
  if (isError) return <>Network Error</>
  const type = data.find((t) => t.id == id)
  return <>{type?.name || "N/A"}</>
}
